/** Resolves which plan panel should highlight a given onboarding task id. */
export function listContainsTaskId(tasks, taskId) {
  if (!taskId || !tasks?.length) {
    return false;
  }
  return tasks.some((task) => task.id === taskId);
}

/** next-action panel wins over unscheduled when the id appears in both lists. */
export function resolveOnboardingHighlightPanelId(
  taskId,
  { nextActionRailSlice, unscheduledTasks },
) {
  if (!taskId) {
    return null;
  }
  if (listContainsTaskId(nextActionRailSlice, taskId)) {
    return 'next-action';
  }
  if (listContainsTaskId(unscheduledTasks, taskId)) {
    return 'unscheduled';
  }
  return null;
}
